import React, { useState } from 'react'
import styled from 'styled-components'

const LayerSwitcher = styled.div<{ $position: string }>`
  position: absolute;
  ${({ $position }) => {
    switch ($position) {
      case 'top-left':
        return 'top: 16px; left: 16px;'
      case 'top-right':
        return 'top: 16px; right: 16px;'
      case 'bottom-left':
        return 'bottom: 16px; left: 16px;'
      case 'bottom-right':
        return 'bottom: 16px; right: 16px;'
      default:
        return 'top: 16px; left: 16px;'
    }
  }}
  background: white;
  border-radius: 12px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.15);
  padding: 4px;
  display: flex;
  gap: 4px;
  z-index: 1;
`

const LayerOptionButton = styled.button<{ $active: boolean }>`
  padding: 8px 16px;
  border: none;
  background: ${({ $active }) =>
    $active ? 'var(--primary, #00ade6)' : 'transparent'};
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  color: ${({ $active }) =>
    $active ? 'white' : 'var(--text-secondary, #6b6b6b)'};
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;

  &:hover {
    background: ${({ $active }) =>
      $active
        ? 'var(--primary-hover, #00a1d6)'
        : 'var(--bg-tertiary, #f5f5f5)'};
    color: ${({ $active }) =>
      $active ? 'white' : 'var(--text-primary, #1a1a1a)'};
  }

  @media (max-width: 768px) {
    padding: 6px 12px;
    font-size: 12px;
  }
`

type LayerType = 'street' | 'satellite'

interface MapLayerSwitcherProps {
  position?: 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right'
  defaultLayer?: LayerType
  onLayerChange?: (layer: LayerType) => void
  streetLabel?: string
  satelliteLabel?: string
}

export const MapLayerSwitcher: React.FC<MapLayerSwitcherProps> = ({
  position = 'top-left',
  defaultLayer = 'street',
  onLayerChange,
  streetLabel = 'Street',
  satelliteLabel = 'Satellite',
}) => {
  const [activeLayer, setActiveLayer] = useState<LayerType>(defaultLayer)

  const handleLayerChange = (layer: LayerType) => {
    setActiveLayer(layer)
    onLayerChange?.(layer)
  }

  return (
    <LayerSwitcher $position={position}>
      <LayerOptionButton
        $active={activeLayer === 'street'}
        onClick={() => handleLayerChange('street')}
      >
        {streetLabel}
      </LayerOptionButton>
      <LayerOptionButton
        $active={activeLayer === 'satellite'}
        onClick={() => handleLayerChange('satellite')}
      >
        {satelliteLabel}
      </LayerOptionButton>
    </LayerSwitcher>
  )
}
